const types = {
  GET_PAYMENT_DUE_START: 'GET_PAYMENT_DUE_START',
  GET_PAYMENT_DUE_SUCCESS: 'GET_PAYMENT_DUE_SUCCESS',
  GET_PAYMENT_DUE_FAILURE: 'GET_PAYMENT_DUE_FAILURE',
};

export default types;
